// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { documentsAbortUpload, documentsClassifyDocument, documentsCompleteUpload, documentsConfirmRevision, documentsCreateDocument, documentsCreateUpload, documentsDeleteFile, documentsFilePresentation, documentsGetDocument, documentsGetUpload, documentsListDocuments, documentsRemoveFileFromDraft, documentsReplaceFileBytes, documentsResolvePresentation, documentsSearchDocuments, documentsSetFileRole, documentsUploadPartUrls, engineeringChangeCatalogueItem, engineeringConfirmAttribute, engineeringCreateCatalogueItem, engineeringCreatePart, engineeringCreateRevision, engineeringDecideAttributeProposal, engineeringDecideSignal, engineeringEnsureRecipe, engineeringGetPart, engineeringGetRecipe, engineeringGetRecipeVersion, engineeringLinkEvidence, engineeringListCatalogue, engineeringPartRevisionReference, engineeringRecordEquivalence, engineeringRecordSignal, engineeringReplacePart, engineeringSaveRecipeVersion, engineeringSearchParts, engineeringTechnicalBasis, engineeringUnlinkEvidence, engineeringUpdatePart, engineeringUpdateRevision, healthLive, healthReady, type Options, platformActivatePolicies, platformChangeCapabilityMapping, platformChangeInvitationRole, platformChangeRole, platformDeactivate, platformGetCapabilityMapping, platformGetMe, platformGetPolicies, platformGetPolicyVersion, platformInvite, platformListAudit, platformListInvitations, platformListMembers, platformListOrganizations, platformListPolicyVersions, platformPatchMe, platformReactivate, platformRenew, platformRevoke, platformSavePolicyDraft, salesActivatePriceBookVersion, salesAddContact, salesCreateCustomer, salesCreatePriceBook, salesCreatePriceBookVersion, salesCreateQuote, salesCreateRequest, salesGetCalculation, salesGetCustomer, salesGetPriceBook, salesGetPriceBookVersion, salesGetQuote, salesGetQuoteVersion, salesGetRequest, salesInternalSummary, salesListCalculations, salesListPriceBooks, salesListSupplierEvidence, salesPreviewCalculation, salesRecordSupplierEvidence, salesSaveCalculation, salesSaveQuoteVersion, salesSearchCustomers, salesSearchQuotes, salesSearchRequests } from '../sdk.gen';
import type { DocumentsAbortUploadData, DocumentsAbortUploadError, DocumentsAbortUploadResponse, DocumentsClassifyDocumentData, DocumentsClassifyDocumentError, DocumentsClassifyDocumentResponse, DocumentsCompleteUploadData, DocumentsCompleteUploadError, DocumentsCompleteUploadResponse, DocumentsConfirmRevisionData, DocumentsConfirmRevisionError, DocumentsConfirmRevisionResponse, DocumentsCreateDocumentData, DocumentsCreateDocumentError, DocumentsCreateDocumentResponse, DocumentsCreateUploadData, DocumentsCreateUploadError, DocumentsCreateUploadResponse, DocumentsDeleteFileData, DocumentsDeleteFileError, DocumentsFilePresentationData, DocumentsFilePresentationError, DocumentsFilePresentationResponse, DocumentsGetDocumentData, DocumentsGetDocumentError, DocumentsGetDocumentResponse, DocumentsGetUploadData, DocumentsGetUploadError, DocumentsGetUploadResponse, DocumentsListDocumentsData, DocumentsListDocumentsError, DocumentsListDocumentsResponse, DocumentsRemoveFileFromDraftData, DocumentsRemoveFileFromDraftError, DocumentsRemoveFileFromDraftResponse, DocumentsReplaceFileBytesData, DocumentsReplaceFileBytesError, DocumentsResolvePresentationData, DocumentsResolvePresentationError, DocumentsResolvePresentationResponse, DocumentsSearchDocumentsData, DocumentsSearchDocumentsError, DocumentsSearchDocumentsResponse, DocumentsSetFileRoleData, DocumentsSetFileRoleError, DocumentsSetFileRoleResponse, DocumentsUploadPartUrlsData, DocumentsUploadPartUrlsError, DocumentsUploadPartUrlsResponse, EngineeringChangeCatalogueItemData, EngineeringChangeCatalogueItemError, EngineeringChangeCatalogueItemResponse, EngineeringConfirmAttributeData, EngineeringConfirmAttributeError, EngineeringConfirmAttributeResponse, EngineeringCreateCatalogueItemData, EngineeringCreateCatalogueItemError, EngineeringCreateCatalogueItemResponse, EngineeringCreatePartData, EngineeringCreatePartError, EngineeringCreatePartResponse, EngineeringCreateRevisionData, EngineeringCreateRevisionError, EngineeringCreateRevisionResponse, EngineeringDecideAttributeProposalData, EngineeringDecideAttributeProposalError, EngineeringDecideAttributeProposalResponse, EngineeringDecideSignalData, EngineeringDecideSignalError, EngineeringDecideSignalResponse, EngineeringEnsureRecipeData, EngineeringEnsureRecipeError, EngineeringEnsureRecipeResponse, EngineeringGetPartData, EngineeringGetPartError, EngineeringGetPartResponse, EngineeringGetRecipeData, EngineeringGetRecipeError, EngineeringGetRecipeResponse, EngineeringGetRecipeVersionData, EngineeringGetRecipeVersionError, EngineeringGetRecipeVersionResponse, EngineeringLinkEvidenceData, EngineeringLinkEvidenceError, EngineeringLinkEvidenceResponse, EngineeringListCatalogueData, EngineeringListCatalogueError, EngineeringListCatalogueResponse, EngineeringPartRevisionReferenceData, EngineeringPartRevisionReferenceError, EngineeringPartRevisionReferenceResponse, EngineeringRecordEquivalenceData, EngineeringRecordEquivalenceError, EngineeringRecordEquivalenceResponse, EngineeringRecordSignalData, EngineeringRecordSignalError, EngineeringRecordSignalResponse, EngineeringReplacePartData, EngineeringReplacePartError, EngineeringReplacePartResponse, EngineeringSaveRecipeVersionData, EngineeringSaveRecipeVersionError, EngineeringSaveRecipeVersionResponse, EngineeringSearchPartsData, EngineeringSearchPartsError, EngineeringSearchPartsResponse, EngineeringTechnicalBasisData, EngineeringTechnicalBasisError, EngineeringTechnicalBasisResponse, EngineeringUnlinkEvidenceData, EngineeringUnlinkEvidenceError, EngineeringUnlinkEvidenceResponse, EngineeringUpdatePartData, EngineeringUpdatePartError, EngineeringUpdatePartResponse, EngineeringUpdateRevisionData, EngineeringUpdateRevisionError, EngineeringUpdateRevisionResponse, HealthLiveData, HealthLiveResponse, HealthReadyData, PlatformActivatePoliciesData, PlatformActivatePoliciesError, PlatformActivatePoliciesResponse, PlatformChangeCapabilityMappingData, PlatformChangeCapabilityMappingError, PlatformChangeCapabilityMappingResponse, PlatformChangeInvitationRoleData, PlatformChangeInvitationRoleError, PlatformChangeInvitationRoleResponse, PlatformChangeRoleData, PlatformChangeRoleError, PlatformChangeRoleResponse, PlatformDeactivateData, PlatformDeactivateError, PlatformDeactivateResponse, PlatformGetCapabilityMappingData, PlatformGetCapabilityMappingError, PlatformGetCapabilityMappingResponse, PlatformGetMeData, PlatformGetMeError, PlatformGetMeResponse, PlatformGetPoliciesData, PlatformGetPoliciesError, PlatformGetPoliciesResponse, PlatformGetPolicyVersionData, PlatformGetPolicyVersionError, PlatformGetPolicyVersionResponse, PlatformInviteData, PlatformInviteError, PlatformInviteResponse, PlatformListAuditData, PlatformListAuditError, PlatformListAuditResponse, PlatformListInvitationsData, PlatformListInvitationsError, PlatformListInvitationsResponse, PlatformListMembersData, PlatformListMembersError, PlatformListMembersResponse, PlatformListOrganizationsData, PlatformListOrganizationsResponse, PlatformListPolicyVersionsData, PlatformListPolicyVersionsError, PlatformListPolicyVersionsResponse, PlatformPatchMeData, PlatformPatchMeError, PlatformPatchMeResponse, PlatformReactivateData, PlatformReactivateError, PlatformReactivateResponse, PlatformRenewData, PlatformRenewError, PlatformRenewResponse, PlatformRevokeData, PlatformRevokeError, PlatformRevokeResponse, PlatformSavePolicyDraftData, PlatformSavePolicyDraftError, PlatformSavePolicyDraftResponse, SalesActivatePriceBookVersionData, SalesActivatePriceBookVersionError, SalesActivatePriceBookVersionResponse, SalesAddContactData, SalesAddContactError, SalesAddContactResponse, SalesCreateCustomerData, SalesCreateCustomerError, SalesCreateCustomerResponse, SalesCreatePriceBookData, SalesCreatePriceBookError, SalesCreatePriceBookResponse, SalesCreatePriceBookVersionData, SalesCreatePriceBookVersionError, SalesCreatePriceBookVersionResponse, SalesCreateQuoteData, SalesCreateQuoteError, SalesCreateQuoteResponse, SalesCreateRequestData, SalesCreateRequestError, SalesCreateRequestResponse, SalesGetCalculationData, SalesGetCalculationError, SalesGetCalculationResponse, SalesGetCustomerData, SalesGetCustomerError, SalesGetCustomerResponse, SalesGetPriceBookData, SalesGetPriceBookError, SalesGetPriceBookResponse, SalesGetPriceBookVersionData, SalesGetPriceBookVersionError, SalesGetPriceBookVersionResponse, SalesGetQuoteData, SalesGetQuoteError, SalesGetQuoteResponse, SalesGetQuoteVersionData, SalesGetQuoteVersionError, SalesGetQuoteVersionResponse, SalesGetRequestData, SalesGetRequestError, SalesGetRequestResponse, SalesInternalSummaryData, SalesInternalSummaryError, SalesInternalSummaryResponse, SalesListCalculationsData, SalesListCalculationsError, SalesListCalculationsResponse, SalesListPriceBooksData, SalesListPriceBooksError, SalesListPriceBooksResponse, SalesListSupplierEvidenceData, SalesListSupplierEvidenceError, SalesListSupplierEvidenceResponse, SalesPreviewCalculationData, SalesPreviewCalculationError, SalesPreviewCalculationResponse, SalesRecordSupplierEvidenceData, SalesRecordSupplierEvidenceError, SalesRecordSupplierEvidenceResponse, SalesSaveCalculationData, SalesSaveCalculationError, SalesSaveCalculationResponse, SalesSaveQuoteVersionData, SalesSaveQuoteVersionError, SalesSaveQuoteVersionResponse, SalesSearchCustomersData, SalesSearchCustomersError, SalesSearchCustomersResponse, SalesSearchQuotesData, SalesSearchQuotesError, SalesSearchQuotesResponse, SalesSearchRequestsData, SalesSearchRequestsError, SalesSearchRequestsResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const documentsListDocumentsQueryKey = (options?: Options<DocumentsListDocumentsData>) => createQueryKey('documentsListDocuments', options);

/**
 * List Documents
 */
export const documentsListDocumentsOptions = (options?: Options<DocumentsListDocumentsData>) => queryOptions<DocumentsListDocumentsResponse, DocumentsListDocumentsError, DocumentsListDocumentsResponse, ReturnType<typeof documentsListDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentsListDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentsListDocumentsQueryKey(options)
});

/**
 * Create Document
 */
export const documentsCreateDocumentMutation = (options?: Partial<Options<DocumentsCreateDocumentData>>): UseMutationOptions<DocumentsCreateDocumentResponse, DocumentsCreateDocumentError, Options<DocumentsCreateDocumentData>> => {
    const mutationOptions: UseMutationOptions<DocumentsCreateDocumentResponse, DocumentsCreateDocumentError, Options<DocumentsCreateDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentsCreateDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentsGetDocumentQueryKey = (options: Options<DocumentsGetDocumentData>) => createQueryKey('documentsGetDocument', options);

/**
 * Get Document
 */
export const documentsGetDocumentOptions = (options: Options<DocumentsGetDocumentData>) => queryOptions<DocumentsGetDocumentResponse, DocumentsGetDocumentError, DocumentsGetDocumentResponse, ReturnType<typeof documentsGetDocumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentsGetDocument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentsGetDocumentQueryKey(options)
});

/**
 * Classify Document
 */
export const documentsClassifyDocumentMutation = (options?: Partial<Options<DocumentsClassifyDocumentData>>): UseMutationOptions<DocumentsClassifyDocumentResponse, DocumentsClassifyDocumentError, Options<DocumentsClassifyDocumentData>> => {
    const mutationOptions: UseMutationOptions<DocumentsClassifyDocumentResponse, DocumentsClassifyDocumentError, Options<DocumentsClassifyDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentsClassifyDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm Revision
 */
export const documentsConfirmRevisionMutation = (options?: Partial<Options<DocumentsConfirmRevisionData>>): UseMutationOptions<DocumentsConfirmRevisionResponse, DocumentsConfirmRevisionError, Options<DocumentsConfirmRevisionData>> => {
    const mutationOptions: UseMutationOptions<DocumentsConfirmRevisionResponse, DocumentsConfirmRevisionError, Options<DocumentsConfirmRevisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentsConfirmRevision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove File From Draft
 *
 * Remove a file from a DRAFT revision (the immutable file stays resolvable).
 */
export const documentsRemoveFileFromDraftMutation = (options?: Partial<Options<DocumentsRemoveFileFromDraftData>>): UseMutationOptions<DocumentsRemoveFileFromDraftResponse, DocumentsRemoveFileFromDraftError, Options<DocumentsRemoveFileFromDraftData>> => {
    const mutationOptions: UseMutationOptions<DocumentsRemoveFileFromDraftResponse, DocumentsRemoveFileFromDraftError, Options<DocumentsRemoveFileFromDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentsRemoveFileFromDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set File Role
 */
export const documentsSetFileRoleMutation = (options?: Partial<Options<DocumentsSetFileRoleData>>): UseMutationOptions<DocumentsSetFileRoleResponse, DocumentsSetFileRoleError, Options<DocumentsSetFileRoleData>> => {
    const mutationOptions: UseMutationOptions<DocumentsSetFileRoleResponse, DocumentsSetFileRoleError, Options<DocumentsSetFileRoleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentsSetFileRole({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete File
 *
 * Always refused in this change: completed files are never hard-deleted
 * (``document.referenced``).
 */
export const documentsDeleteFileMutation = (options?: Partial<Options<DocumentsDeleteFileData>>): UseMutationOptions<unknown, DocumentsDeleteFileError, Options<DocumentsDeleteFileData>> => {
    const mutationOptions: UseMutationOptions<unknown, DocumentsDeleteFileError, Options<DocumentsDeleteFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentsDeleteFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Replace File Bytes
 *
 * Always refused: completed bytes are immutable (``document.file_immutable``).
 */
export const documentsReplaceFileBytesMutation = (options?: Partial<Options<DocumentsReplaceFileBytesData>>): UseMutationOptions<unknown, DocumentsReplaceFileBytesError, Options<DocumentsReplaceFileBytesData>> => {
    const mutationOptions: UseMutationOptions<unknown, DocumentsReplaceFileBytesError, Options<DocumentsReplaceFileBytesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentsReplaceFileBytes({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentsFilePresentationQueryKey = (options: Options<DocumentsFilePresentationData>) => createQueryKey('documentsFilePresentation', options);

/**
 * File Presentation
 */
export const documentsFilePresentationOptions = (options: Options<DocumentsFilePresentationData>) => queryOptions<DocumentsFilePresentationResponse, DocumentsFilePresentationError, DocumentsFilePresentationResponse, ReturnType<typeof documentsFilePresentationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentsFilePresentation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentsFilePresentationQueryKey(options)
});

/**
 * Resolve Presentation
 */
export const documentsResolvePresentationMutation = (options?: Partial<Options<DocumentsResolvePresentationData>>): UseMutationOptions<DocumentsResolvePresentationResponse, DocumentsResolvePresentationError, Options<DocumentsResolvePresentationData>> => {
    const mutationOptions: UseMutationOptions<DocumentsResolvePresentationResponse, DocumentsResolvePresentationError, Options<DocumentsResolvePresentationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentsResolvePresentation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentsSearchDocumentsQueryKey = (options?: Options<DocumentsSearchDocumentsData>) => createQueryKey('documentsSearchDocuments', options);

/**
 * Search Documents
 *
 * Filename, document number, title or exact SHA-256 within the active organization.
 */
export const documentsSearchDocumentsOptions = (options?: Options<DocumentsSearchDocumentsData>) => queryOptions<DocumentsSearchDocumentsResponse, DocumentsSearchDocumentsError, DocumentsSearchDocumentsResponse, ReturnType<typeof documentsSearchDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentsSearchDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentsSearchDocumentsQueryKey(options)
});

/**
 * Create Upload
 */
export const documentsCreateUploadMutation = (options?: Partial<Options<DocumentsCreateUploadData>>): UseMutationOptions<DocumentsCreateUploadResponse, DocumentsCreateUploadError, Options<DocumentsCreateUploadData>> => {
    const mutationOptions: UseMutationOptions<DocumentsCreateUploadResponse, DocumentsCreateUploadError, Options<DocumentsCreateUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentsCreateUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const documentsGetUploadQueryKey = (options: Options<DocumentsGetUploadData>) => createQueryKey('documentsGetUpload', options);

/**
 * Get Upload
 */
export const documentsGetUploadOptions = (options: Options<DocumentsGetUploadData>) => queryOptions<DocumentsGetUploadResponse, DocumentsGetUploadError, DocumentsGetUploadResponse, ReturnType<typeof documentsGetUploadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await documentsGetUpload({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: documentsGetUploadQueryKey(options)
});

/**
 * Abort Upload
 */
export const documentsAbortUploadMutation = (options?: Partial<Options<DocumentsAbortUploadData>>): UseMutationOptions<DocumentsAbortUploadResponse, DocumentsAbortUploadError, Options<DocumentsAbortUploadData>> => {
    const mutationOptions: UseMutationOptions<DocumentsAbortUploadResponse, DocumentsAbortUploadError, Options<DocumentsAbortUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentsAbortUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Complete Upload
 */
export const documentsCompleteUploadMutation = (options?: Partial<Options<DocumentsCompleteUploadData>>): UseMutationOptions<DocumentsCompleteUploadResponse, DocumentsCompleteUploadError, Options<DocumentsCompleteUploadData>> => {
    const mutationOptions: UseMutationOptions<DocumentsCompleteUploadResponse, DocumentsCompleteUploadError, Options<DocumentsCompleteUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentsCompleteUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Part Urls
 */
export const documentsUploadPartUrlsMutation = (options?: Partial<Options<DocumentsUploadPartUrlsData>>): UseMutationOptions<DocumentsUploadPartUrlsResponse, DocumentsUploadPartUrlsError, Options<DocumentsUploadPartUrlsData>> => {
    const mutationOptions: UseMutationOptions<DocumentsUploadPartUrlsResponse, DocumentsUploadPartUrlsError, Options<DocumentsUploadPartUrlsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await documentsUploadPartUrls({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const engineeringListCatalogueQueryKey = (options?: Options<EngineeringListCatalogueData>) => createQueryKey('engineeringListCatalogue', options);

/**
 * List Catalogue
 */
export const engineeringListCatalogueOptions = (options?: Options<EngineeringListCatalogueData>) => queryOptions<EngineeringListCatalogueResponse, EngineeringListCatalogueError, EngineeringListCatalogueResponse, ReturnType<typeof engineeringListCatalogueQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await engineeringListCatalogue({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: engineeringListCatalogueQueryKey(options)
});

/**
 * Create Catalogue Item
 */
export const engineeringCreateCatalogueItemMutation = (options?: Partial<Options<EngineeringCreateCatalogueItemData>>): UseMutationOptions<EngineeringCreateCatalogueItemResponse, EngineeringCreateCatalogueItemError, Options<EngineeringCreateCatalogueItemData>> => {
    const mutationOptions: UseMutationOptions<EngineeringCreateCatalogueItemResponse, EngineeringCreateCatalogueItemError, Options<EngineeringCreateCatalogueItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await engineeringCreateCatalogueItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change Catalogue Item
 */
export const engineeringChangeCatalogueItemMutation = (options?: Partial<Options<EngineeringChangeCatalogueItemData>>): UseMutationOptions<EngineeringChangeCatalogueItemResponse, EngineeringChangeCatalogueItemError, Options<EngineeringChangeCatalogueItemData>> => {
    const mutationOptions: UseMutationOptions<EngineeringChangeCatalogueItemResponse, EngineeringChangeCatalogueItemError, Options<EngineeringChangeCatalogueItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await engineeringChangeCatalogueItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Revision
 */
export const engineeringUpdateRevisionMutation = (options?: Partial<Options<EngineeringUpdateRevisionData>>): UseMutationOptions<EngineeringUpdateRevisionResponse, EngineeringUpdateRevisionError, Options<EngineeringUpdateRevisionData>> => {
    const mutationOptions: UseMutationOptions<EngineeringUpdateRevisionResponse, EngineeringUpdateRevisionError, Options<EngineeringUpdateRevisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await engineeringUpdateRevision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Decide Attribute Proposal
 */
export const engineeringDecideAttributeProposalMutation = (options?: Partial<Options<EngineeringDecideAttributeProposalData>>): UseMutationOptions<EngineeringDecideAttributeProposalResponse, EngineeringDecideAttributeProposalError, Options<EngineeringDecideAttributeProposalData>> => {
    const mutationOptions: UseMutationOptions<EngineeringDecideAttributeProposalResponse, EngineeringDecideAttributeProposalError, Options<EngineeringDecideAttributeProposalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await engineeringDecideAttributeProposal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm Attribute
 */
export const engineeringConfirmAttributeMutation = (options?: Partial<Options<EngineeringConfirmAttributeData>>): UseMutationOptions<EngineeringConfirmAttributeResponse, EngineeringConfirmAttributeError, Options<EngineeringConfirmAttributeData>> => {
    const mutationOptions: UseMutationOptions<EngineeringConfirmAttributeResponse, EngineeringConfirmAttributeError, Options<EngineeringConfirmAttributeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await engineeringConfirmAttribute({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Link Evidence
 */
export const engineeringLinkEvidenceMutation = (options?: Partial<Options<EngineeringLinkEvidenceData>>): UseMutationOptions<EngineeringLinkEvidenceResponse, EngineeringLinkEvidenceError, Options<EngineeringLinkEvidenceData>> => {
    const mutationOptions: UseMutationOptions<EngineeringLinkEvidenceResponse, EngineeringLinkEvidenceError, Options<EngineeringLinkEvidenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await engineeringLinkEvidence({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unlink Evidence
 *
 * Unlinking is recorded (append-only history); documents are never touched.
 */
export const engineeringUnlinkEvidenceMutation = (options?: Partial<Options<EngineeringUnlinkEvidenceData>>): UseMutationOptions<EngineeringUnlinkEvidenceResponse, EngineeringUnlinkEvidenceError, Options<EngineeringUnlinkEvidenceData>> => {
    const mutationOptions: UseMutationOptions<EngineeringUnlinkEvidenceResponse, EngineeringUnlinkEvidenceError, Options<EngineeringUnlinkEvidenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await engineeringUnlinkEvidence({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Ensure Recipe
 *
 * The revision's estimate recipe (created on first use; idempotent).
 */
export const engineeringEnsureRecipeMutation = (options?: Partial<Options<EngineeringEnsureRecipeData>>): UseMutationOptions<EngineeringEnsureRecipeResponse, EngineeringEnsureRecipeError, Options<EngineeringEnsureRecipeData>> => {
    const mutationOptions: UseMutationOptions<EngineeringEnsureRecipeResponse, EngineeringEnsureRecipeError, Options<EngineeringEnsureRecipeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await engineeringEnsureRecipe({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const engineeringPartRevisionReferenceQueryKey = (options: Options<EngineeringPartRevisionReferenceData>) => createQueryKey('engineeringPartRevisionReference', options);

/**
 * Part Revision Reference
 */
export const engineeringPartRevisionReferenceOptions = (options: Options<EngineeringPartRevisionReferenceData>) => queryOptions<EngineeringPartRevisionReferenceResponse, EngineeringPartRevisionReferenceError, EngineeringPartRevisionReferenceResponse, ReturnType<typeof engineeringPartRevisionReferenceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await engineeringPartRevisionReference({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: engineeringPartRevisionReferenceQueryKey(options)
});

export const engineeringSearchPartsQueryKey = (options?: Options<EngineeringSearchPartsData>) => createQueryKey('engineeringSearchParts', options);

/**
 * Search Parts
 *
 * Part number, placeholder, name, revision label or linked drawing number/filename.
 */
export const engineeringSearchPartsOptions = (options?: Options<EngineeringSearchPartsData>) => queryOptions<EngineeringSearchPartsResponse, EngineeringSearchPartsError, EngineeringSearchPartsResponse, ReturnType<typeof engineeringSearchPartsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await engineeringSearchParts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: engineeringSearchPartsQueryKey(options)
});

/**
 * Create Part
 */
export const engineeringCreatePartMutation = (options?: Partial<Options<EngineeringCreatePartData>>): UseMutationOptions<EngineeringCreatePartResponse, EngineeringCreatePartError, Options<EngineeringCreatePartData>> => {
    const mutationOptions: UseMutationOptions<EngineeringCreatePartResponse, EngineeringCreatePartError, Options<EngineeringCreatePartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await engineeringCreatePart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const engineeringGetPartQueryKey = (options: Options<EngineeringGetPartData>) => createQueryKey('engineeringGetPart', options);

/**
 * Get Part
 */
export const engineeringGetPartOptions = (options: Options<EngineeringGetPartData>) => queryOptions<EngineeringGetPartResponse, EngineeringGetPartError, EngineeringGetPartResponse, ReturnType<typeof engineeringGetPartQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await engineeringGetPart({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: engineeringGetPartQueryKey(options)
});

/**
 * Update Part
 */
export const engineeringUpdatePartMutation = (options?: Partial<Options<EngineeringUpdatePartData>>): UseMutationOptions<EngineeringUpdatePartResponse, EngineeringUpdatePartError, Options<EngineeringUpdatePartData>> => {
    const mutationOptions: UseMutationOptions<EngineeringUpdatePartResponse, EngineeringUpdatePartError, Options<EngineeringUpdatePartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await engineeringUpdatePart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Equivalence
 */
export const engineeringRecordEquivalenceMutation = (options?: Partial<Options<EngineeringRecordEquivalenceData>>): UseMutationOptions<EngineeringRecordEquivalenceResponse, EngineeringRecordEquivalenceError, Options<EngineeringRecordEquivalenceData>> => {
    const mutationOptions: UseMutationOptions<EngineeringRecordEquivalenceResponse, EngineeringRecordEquivalenceError, Options<EngineeringRecordEquivalenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await engineeringRecordEquivalence({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Replace Part
 */
export const engineeringReplacePartMutation = (options?: Partial<Options<EngineeringReplacePartData>>): UseMutationOptions<EngineeringReplacePartResponse, EngineeringReplacePartError, Options<EngineeringReplacePartData>> => {
    const mutationOptions: UseMutationOptions<EngineeringReplacePartResponse, EngineeringReplacePartError, Options<EngineeringReplacePartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await engineeringReplacePart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Revision
 */
export const engineeringCreateRevisionMutation = (options?: Partial<Options<EngineeringCreateRevisionData>>): UseMutationOptions<EngineeringCreateRevisionResponse, EngineeringCreateRevisionError, Options<EngineeringCreateRevisionData>> => {
    const mutationOptions: UseMutationOptions<EngineeringCreateRevisionResponse, EngineeringCreateRevisionError, Options<EngineeringCreateRevisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await engineeringCreateRevision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record Signal
 */
export const engineeringRecordSignalMutation = (options?: Partial<Options<EngineeringRecordSignalData>>): UseMutationOptions<EngineeringRecordSignalResponse, EngineeringRecordSignalError, Options<EngineeringRecordSignalData>> => {
    const mutationOptions: UseMutationOptions<EngineeringRecordSignalResponse, EngineeringRecordSignalError, Options<EngineeringRecordSignalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await engineeringRecordSignal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Decide Signal
 */
export const engineeringDecideSignalMutation = (options?: Partial<Options<EngineeringDecideSignalData>>): UseMutationOptions<EngineeringDecideSignalResponse, EngineeringDecideSignalError, Options<EngineeringDecideSignalData>> => {
    const mutationOptions: UseMutationOptions<EngineeringDecideSignalResponse, EngineeringDecideSignalError, Options<EngineeringDecideSignalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await engineeringDecideSignal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const engineeringGetRecipeVersionQueryKey = (options: Options<EngineeringGetRecipeVersionData>) => createQueryKey('engineeringGetRecipeVersion', options);

/**
 * Get Recipe Version
 */
export const engineeringGetRecipeVersionOptions = (options: Options<EngineeringGetRecipeVersionData>) => queryOptions<EngineeringGetRecipeVersionResponse, EngineeringGetRecipeVersionError, EngineeringGetRecipeVersionResponse, ReturnType<typeof engineeringGetRecipeVersionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await engineeringGetRecipeVersion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: engineeringGetRecipeVersionQueryKey(options)
});

export const engineeringGetRecipeQueryKey = (options: Options<EngineeringGetRecipeData>) => createQueryKey('engineeringGetRecipe', options);

/**
 * Get Recipe
 */
export const engineeringGetRecipeOptions = (options: Options<EngineeringGetRecipeData>) => queryOptions<EngineeringGetRecipeResponse, EngineeringGetRecipeError, EngineeringGetRecipeResponse, ReturnType<typeof engineeringGetRecipeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await engineeringGetRecipe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: engineeringGetRecipeQueryKey(options)
});

/**
 * Save Recipe Version
 */
export const engineeringSaveRecipeVersionMutation = (options?: Partial<Options<EngineeringSaveRecipeVersionData>>): UseMutationOptions<EngineeringSaveRecipeVersionResponse, EngineeringSaveRecipeVersionError, Options<EngineeringSaveRecipeVersionData>> => {
    const mutationOptions: UseMutationOptions<EngineeringSaveRecipeVersionResponse, EngineeringSaveRecipeVersionError, Options<EngineeringSaveRecipeVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await engineeringSaveRecipeVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const engineeringTechnicalBasisQueryKey = (options: Options<EngineeringTechnicalBasisData>) => createQueryKey('engineeringTechnicalBasis', options);

/**
 * Technical Basis
 *
 * A draft read with current revision tokens; it never releases or locks anything.
 */
export const engineeringTechnicalBasisOptions = (options: Options<EngineeringTechnicalBasisData>) => queryOptions<EngineeringTechnicalBasisResponse, EngineeringTechnicalBasisError, EngineeringTechnicalBasisResponse, ReturnType<typeof engineeringTechnicalBasisQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await engineeringTechnicalBasis({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: engineeringTechnicalBasisQueryKey(options)
});

export const healthLiveQueryKey = (options?: Options<HealthLiveData>) => createQueryKey('healthLive', options);

/**
 * Live
 */
export const healthLiveOptions = (options?: Options<HealthLiveData>) => queryOptions<HealthLiveResponse, DefaultError, HealthLiveResponse, ReturnType<typeof healthLiveQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthLive({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthLiveQueryKey(options)
});

export const healthReadyQueryKey = (options?: Options<HealthReadyData>) => createQueryKey('healthReady', options);

/**
 * Ready
 */
export const healthReadyOptions = (options?: Options<HealthReadyData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof healthReadyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthReady({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthReadyQueryKey(options)
});

export const platformListAuditQueryKey = (options?: Options<PlatformListAuditData>) => createQueryKey('platformListAudit', options);

/**
 * List Audit
 */
export const platformListAuditOptions = (options?: Options<PlatformListAuditData>) => queryOptions<PlatformListAuditResponse, PlatformListAuditError, PlatformListAuditResponse, ReturnType<typeof platformListAuditQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await platformListAudit({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: platformListAuditQueryKey(options)
});

export const platformListInvitationsQueryKey = (options?: Options<PlatformListInvitationsData>) => createQueryKey('platformListInvitations', options);

/**
 * List Invitations
 */
export const platformListInvitationsOptions = (options?: Options<PlatformListInvitationsData>) => queryOptions<PlatformListInvitationsResponse, PlatformListInvitationsError, PlatformListInvitationsResponse, ReturnType<typeof platformListInvitationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await platformListInvitations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: platformListInvitationsQueryKey(options)
});

/**
 * Invite
 */
export const platformInviteMutation = (options?: Partial<Options<PlatformInviteData>>): UseMutationOptions<PlatformInviteResponse, PlatformInviteError, Options<PlatformInviteData>> => {
    const mutationOptions: UseMutationOptions<PlatformInviteResponse, PlatformInviteError, Options<PlatformInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change Invitation Role
 */
export const platformChangeInvitationRoleMutation = (options?: Partial<Options<PlatformChangeInvitationRoleData>>): UseMutationOptions<PlatformChangeInvitationRoleResponse, PlatformChangeInvitationRoleError, Options<PlatformChangeInvitationRoleData>> => {
    const mutationOptions: UseMutationOptions<PlatformChangeInvitationRoleResponse, PlatformChangeInvitationRoleError, Options<PlatformChangeInvitationRoleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformChangeInvitationRole({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Renew
 */
export const platformRenewMutation = (options?: Partial<Options<PlatformRenewData>>): UseMutationOptions<PlatformRenewResponse, PlatformRenewError, Options<PlatformRenewData>> => {
    const mutationOptions: UseMutationOptions<PlatformRenewResponse, PlatformRenewError, Options<PlatformRenewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformRenew({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke
 */
export const platformRevokeMutation = (options?: Partial<Options<PlatformRevokeData>>): UseMutationOptions<PlatformRevokeResponse, PlatformRevokeError, Options<PlatformRevokeData>> => {
    const mutationOptions: UseMutationOptions<PlatformRevokeResponse, PlatformRevokeError, Options<PlatformRevokeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformRevoke({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const platformGetMeQueryKey = (options?: Options<PlatformGetMeData>) => createQueryKey('platformGetMe', options);

/**
 * Get Me
 */
export const platformGetMeOptions = (options?: Options<PlatformGetMeData>) => queryOptions<PlatformGetMeResponse, PlatformGetMeError, PlatformGetMeResponse, ReturnType<typeof platformGetMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await platformGetMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: platformGetMeQueryKey(options)
});

/**
 * Patch Me
 */
export const platformPatchMeMutation = (options?: Partial<Options<PlatformPatchMeData>>): UseMutationOptions<PlatformPatchMeResponse, PlatformPatchMeError, Options<PlatformPatchMeData>> => {
    const mutationOptions: UseMutationOptions<PlatformPatchMeResponse, PlatformPatchMeError, Options<PlatformPatchMeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformPatchMe({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const platformListMembersQueryKey = (options?: Options<PlatformListMembersData>) => createQueryKey('platformListMembers', options);

/**
 * List Members
 */
export const platformListMembersOptions = (options?: Options<PlatformListMembersData>) => queryOptions<PlatformListMembersResponse, PlatformListMembersError, PlatformListMembersResponse, ReturnType<typeof platformListMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await platformListMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: platformListMembersQueryKey(options)
});

/**
 * Change Role
 */
export const platformChangeRoleMutation = (options?: Partial<Options<PlatformChangeRoleData>>): UseMutationOptions<PlatformChangeRoleResponse, PlatformChangeRoleError, Options<PlatformChangeRoleData>> => {
    const mutationOptions: UseMutationOptions<PlatformChangeRoleResponse, PlatformChangeRoleError, Options<PlatformChangeRoleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformChangeRole({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deactivate
 */
export const platformDeactivateMutation = (options?: Partial<Options<PlatformDeactivateData>>): UseMutationOptions<PlatformDeactivateResponse, PlatformDeactivateError, Options<PlatformDeactivateData>> => {
    const mutationOptions: UseMutationOptions<PlatformDeactivateResponse, PlatformDeactivateError, Options<PlatformDeactivateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformDeactivate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reactivate
 */
export const platformReactivateMutation = (options?: Partial<Options<PlatformReactivateData>>): UseMutationOptions<PlatformReactivateResponse, PlatformReactivateError, Options<PlatformReactivateData>> => {
    const mutationOptions: UseMutationOptions<PlatformReactivateResponse, PlatformReactivateError, Options<PlatformReactivateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformReactivate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const platformListOrganizationsQueryKey = (options?: Options<PlatformListOrganizationsData>) => createQueryKey('platformListOrganizations', options);

/**
 * List Organizations
 */
export const platformListOrganizationsOptions = (options?: Options<PlatformListOrganizationsData>) => queryOptions<PlatformListOrganizationsResponse, DefaultError, PlatformListOrganizationsResponse, ReturnType<typeof platformListOrganizationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await platformListOrganizations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: platformListOrganizationsQueryKey(options)
});

export const platformGetCapabilityMappingQueryKey = (options: Options<PlatformGetCapabilityMappingData>) => createQueryKey('platformGetCapabilityMapping', options);

/**
 * Get Capability Mapping
 */
export const platformGetCapabilityMappingOptions = (options: Options<PlatformGetCapabilityMappingData>) => queryOptions<PlatformGetCapabilityMappingResponse, PlatformGetCapabilityMappingError, PlatformGetCapabilityMappingResponse, ReturnType<typeof platformGetCapabilityMappingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await platformGetCapabilityMapping({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: platformGetCapabilityMappingQueryKey(options)
});

/**
 * Change Capability Mapping
 */
export const platformChangeCapabilityMappingMutation = (options?: Partial<Options<PlatformChangeCapabilityMappingData>>): UseMutationOptions<PlatformChangeCapabilityMappingResponse, PlatformChangeCapabilityMappingError, Options<PlatformChangeCapabilityMappingData>> => {
    const mutationOptions: UseMutationOptions<PlatformChangeCapabilityMappingResponse, PlatformChangeCapabilityMappingError, Options<PlatformChangeCapabilityMappingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformChangeCapabilityMapping({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const platformGetPoliciesQueryKey = (options: Options<PlatformGetPoliciesData>) => createQueryKey('platformGetPolicies', options);

/**
 * Get Policies
 */
export const platformGetPoliciesOptions = (options: Options<PlatformGetPoliciesData>) => queryOptions<PlatformGetPoliciesResponse, PlatformGetPoliciesError, PlatformGetPoliciesResponse, ReturnType<typeof platformGetPoliciesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await platformGetPolicies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: platformGetPoliciesQueryKey(options)
});

/**
 * Activate Policies
 */
export const platformActivatePoliciesMutation = (options?: Partial<Options<PlatformActivatePoliciesData>>): UseMutationOptions<PlatformActivatePoliciesResponse, PlatformActivatePoliciesError, Options<PlatformActivatePoliciesData>> => {
    const mutationOptions: UseMutationOptions<PlatformActivatePoliciesResponse, PlatformActivatePoliciesError, Options<PlatformActivatePoliciesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformActivatePolicies({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Save Policy Draft
 */
export const platformSavePolicyDraftMutation = (options?: Partial<Options<PlatformSavePolicyDraftData>>): UseMutationOptions<PlatformSavePolicyDraftResponse, PlatformSavePolicyDraftError, Options<PlatformSavePolicyDraftData>> => {
    const mutationOptions: UseMutationOptions<PlatformSavePolicyDraftResponse, PlatformSavePolicyDraftError, Options<PlatformSavePolicyDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformSavePolicyDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const platformListPolicyVersionsQueryKey = (options: Options<PlatformListPolicyVersionsData>) => createQueryKey('platformListPolicyVersions', options);

/**
 * List Policy Versions
 */
export const platformListPolicyVersionsOptions = (options: Options<PlatformListPolicyVersionsData>) => queryOptions<PlatformListPolicyVersionsResponse, PlatformListPolicyVersionsError, PlatformListPolicyVersionsResponse, ReturnType<typeof platformListPolicyVersionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await platformListPolicyVersions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: platformListPolicyVersionsQueryKey(options)
});

export const platformGetPolicyVersionQueryKey = (options: Options<PlatformGetPolicyVersionData>) => createQueryKey('platformGetPolicyVersion', options);

/**
 * Get Policy Version
 */
export const platformGetPolicyVersionOptions = (options: Options<PlatformGetPolicyVersionData>) => queryOptions<PlatformGetPolicyVersionResponse, PlatformGetPolicyVersionError, PlatformGetPolicyVersionResponse, ReturnType<typeof platformGetPolicyVersionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await platformGetPolicyVersion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: platformGetPolicyVersionQueryKey(options)
});

/**
 * Save Calculation
 */
export const salesSaveCalculationMutation = (options?: Partial<Options<SalesSaveCalculationData>>): UseMutationOptions<SalesSaveCalculationResponse, SalesSaveCalculationError, Options<SalesSaveCalculationData>> => {
    const mutationOptions: UseMutationOptions<SalesSaveCalculationResponse, SalesSaveCalculationError, Options<SalesSaveCalculationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesSaveCalculation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preview Calculation
 *
 * Transient: creates no calculation revision and no decision record.
 */
export const salesPreviewCalculationMutation = (options?: Partial<Options<SalesPreviewCalculationData>>): UseMutationOptions<SalesPreviewCalculationResponse, SalesPreviewCalculationError, Options<SalesPreviewCalculationData>> => {
    const mutationOptions: UseMutationOptions<SalesPreviewCalculationResponse, SalesPreviewCalculationError, Options<SalesPreviewCalculationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesPreviewCalculation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const salesGetCalculationQueryKey = (options: Options<SalesGetCalculationData>) => createQueryKey('salesGetCalculation', options);

/**
 * Get Calculation
 */
export const salesGetCalculationOptions = (options: Options<SalesGetCalculationData>) => queryOptions<SalesGetCalculationResponse, SalesGetCalculationError, SalesGetCalculationResponse, ReturnType<typeof salesGetCalculationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesGetCalculation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: salesGetCalculationQueryKey(options)
});

export const salesSearchCustomersQueryKey = (options?: Options<SalesSearchCustomersData>) => createQueryKey('salesSearchCustomers', options);

/**
 * Search Customers
 */
export const salesSearchCustomersOptions = (options?: Options<SalesSearchCustomersData>) => queryOptions<SalesSearchCustomersResponse, SalesSearchCustomersError, SalesSearchCustomersResponse, ReturnType<typeof salesSearchCustomersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesSearchCustomers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: salesSearchCustomersQueryKey(options)
});

/**
 * Create Customer
 */
export const salesCreateCustomerMutation = (options?: Partial<Options<SalesCreateCustomerData>>): UseMutationOptions<SalesCreateCustomerResponse, SalesCreateCustomerError, Options<SalesCreateCustomerData>> => {
    const mutationOptions: UseMutationOptions<SalesCreateCustomerResponse, SalesCreateCustomerError, Options<SalesCreateCustomerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateCustomer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const salesGetCustomerQueryKey = (options: Options<SalesGetCustomerData>) => createQueryKey('salesGetCustomer', options);

/**
 * Get Customer
 */
export const salesGetCustomerOptions = (options: Options<SalesGetCustomerData>) => queryOptions<SalesGetCustomerResponse, SalesGetCustomerError, SalesGetCustomerResponse, ReturnType<typeof salesGetCustomerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesGetCustomer({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: salesGetCustomerQueryKey(options)
});

/**
 * Add Contact
 */
export const salesAddContactMutation = (options?: Partial<Options<SalesAddContactData>>): UseMutationOptions<SalesAddContactResponse, SalesAddContactError, Options<SalesAddContactData>> => {
    const mutationOptions: UseMutationOptions<SalesAddContactResponse, SalesAddContactError, Options<SalesAddContactData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesAddContact({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const salesListCalculationsQueryKey = (options: Options<SalesListCalculationsData>) => createQueryKey('salesListCalculations', options);

/**
 * List Calculations
 */
export const salesListCalculationsOptions = (options: Options<SalesListCalculationsData>) => queryOptions<SalesListCalculationsResponse, SalesListCalculationsError, SalesListCalculationsResponse, ReturnType<typeof salesListCalculationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesListCalculations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: salesListCalculationsQueryKey(options)
});

export const salesGetPriceBookVersionQueryKey = (options: Options<SalesGetPriceBookVersionData>) => createQueryKey('salesGetPriceBookVersion', options);

/**
 * Get Price Book Version
 */
export const salesGetPriceBookVersionOptions = (options: Options<SalesGetPriceBookVersionData>) => queryOptions<SalesGetPriceBookVersionResponse, SalesGetPriceBookVersionError, SalesGetPriceBookVersionResponse, ReturnType<typeof salesGetPriceBookVersionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesGetPriceBookVersion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: salesGetPriceBookVersionQueryKey(options)
});

export const salesListPriceBooksQueryKey = (options?: Options<SalesListPriceBooksData>) => createQueryKey('salesListPriceBooks', options);

/**
 * List Price Books
 */
export const salesListPriceBooksOptions = (options?: Options<SalesListPriceBooksData>) => queryOptions<SalesListPriceBooksResponse, SalesListPriceBooksError, SalesListPriceBooksResponse, ReturnType<typeof salesListPriceBooksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesListPriceBooks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: salesListPriceBooksQueryKey(options)
});

/**
 * Create Price Book
 */
export const salesCreatePriceBookMutation = (options?: Partial<Options<SalesCreatePriceBookData>>): UseMutationOptions<SalesCreatePriceBookResponse, SalesCreatePriceBookError, Options<SalesCreatePriceBookData>> => {
    const mutationOptions: UseMutationOptions<SalesCreatePriceBookResponse, SalesCreatePriceBookError, Options<SalesCreatePriceBookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreatePriceBook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const salesGetPriceBookQueryKey = (options: Options<SalesGetPriceBookData>) => createQueryKey('salesGetPriceBook', options);

/**
 * Get Price Book
 */
export const salesGetPriceBookOptions = (options: Options<SalesGetPriceBookData>) => queryOptions<SalesGetPriceBookResponse, SalesGetPriceBookError, SalesGetPriceBookResponse, ReturnType<typeof salesGetPriceBookQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesGetPriceBook({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: salesGetPriceBookQueryKey(options)
});

/**
 * Activate Price Book Version
 */
export const salesActivatePriceBookVersionMutation = (options?: Partial<Options<SalesActivatePriceBookVersionData>>): UseMutationOptions<SalesActivatePriceBookVersionResponse, SalesActivatePriceBookVersionError, Options<SalesActivatePriceBookVersionData>> => {
    const mutationOptions: UseMutationOptions<SalesActivatePriceBookVersionResponse, SalesActivatePriceBookVersionError, Options<SalesActivatePriceBookVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesActivatePriceBookVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Price Book Version
 */
export const salesCreatePriceBookVersionMutation = (options?: Partial<Options<SalesCreatePriceBookVersionData>>): UseMutationOptions<SalesCreatePriceBookVersionResponse, SalesCreatePriceBookVersionError, Options<SalesCreatePriceBookVersionData>> => {
    const mutationOptions: UseMutationOptions<SalesCreatePriceBookVersionResponse, SalesCreatePriceBookVersionError, Options<SalesCreatePriceBookVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreatePriceBookVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const salesGetQuoteVersionQueryKey = (options: Options<SalesGetQuoteVersionData>) => createQueryKey('salesGetQuoteVersion', options);

/**
 * Get Quote Version
 */
export const salesGetQuoteVersionOptions = (options: Options<SalesGetQuoteVersionData>) => queryOptions<SalesGetQuoteVersionResponse, SalesGetQuoteVersionError, SalesGetQuoteVersionResponse, ReturnType<typeof salesGetQuoteVersionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesGetQuoteVersion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: salesGetQuoteVersionQueryKey(options)
});

export const salesInternalSummaryQueryKey = (options: Options<SalesInternalSummaryData>) => createQueryKey('salesInternalSummary', options);

/**
 * Internal Summary
 *
 * The exact version with internal cost data for the not-an-offer print (read only).
 */
export const salesInternalSummaryOptions = (options: Options<SalesInternalSummaryData>) => queryOptions<SalesInternalSummaryResponse, SalesInternalSummaryError, SalesInternalSummaryResponse, ReturnType<typeof salesInternalSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesInternalSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: salesInternalSummaryQueryKey(options)
});

export const salesSearchQuotesQueryKey = (options?: Options<SalesSearchQuotesData>) => createQueryKey('salesSearchQuotes', options);

/**
 * Search Quotes
 *
 * Title, request number or customer name.
 */
export const salesSearchQuotesOptions = (options?: Options<SalesSearchQuotesData>) => queryOptions<SalesSearchQuotesResponse, SalesSearchQuotesError, SalesSearchQuotesResponse, ReturnType<typeof salesSearchQuotesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesSearchQuotes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: salesSearchQuotesQueryKey(options)
});

/**
 * Create Quote
 */
export const salesCreateQuoteMutation = (options?: Partial<Options<SalesCreateQuoteData>>): UseMutationOptions<SalesCreateQuoteResponse, SalesCreateQuoteError, Options<SalesCreateQuoteData>> => {
    const mutationOptions: UseMutationOptions<SalesCreateQuoteResponse, SalesCreateQuoteError, Options<SalesCreateQuoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateQuote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const salesGetQuoteQueryKey = (options: Options<SalesGetQuoteData>) => createQueryKey('salesGetQuote', options);

/**
 * Get Quote
 */
export const salesGetQuoteOptions = (options: Options<SalesGetQuoteData>) => queryOptions<SalesGetQuoteResponse, SalesGetQuoteError, SalesGetQuoteResponse, ReturnType<typeof salesGetQuoteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesGetQuote({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: salesGetQuoteQueryKey(options)
});

/**
 * Save Quote Version
 */
export const salesSaveQuoteVersionMutation = (options?: Partial<Options<SalesSaveQuoteVersionData>>): UseMutationOptions<SalesSaveQuoteVersionResponse, SalesSaveQuoteVersionError, Options<SalesSaveQuoteVersionData>> => {
    const mutationOptions: UseMutationOptions<SalesSaveQuoteVersionResponse, SalesSaveQuoteVersionError, Options<SalesSaveQuoteVersionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesSaveQuoteVersion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const salesSearchRequestsQueryKey = (options?: Options<SalesSearchRequestsData>) => createQueryKey('salesSearchRequests', options);

/**
 * Search Requests
 *
 * Request number, customer name, line description or linked drawing filename.
 */
export const salesSearchRequestsOptions = (options?: Options<SalesSearchRequestsData>) => queryOptions<SalesSearchRequestsResponse, SalesSearchRequestsError, SalesSearchRequestsResponse, ReturnType<typeof salesSearchRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesSearchRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: salesSearchRequestsQueryKey(options)
});

/**
 * Create Request
 */
export const salesCreateRequestMutation = (options?: Partial<Options<SalesCreateRequestData>>): UseMutationOptions<SalesCreateRequestResponse, SalesCreateRequestError, Options<SalesCreateRequestData>> => {
    const mutationOptions: UseMutationOptions<SalesCreateRequestResponse, SalesCreateRequestError, Options<SalesCreateRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesCreateRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const salesGetRequestQueryKey = (options: Options<SalesGetRequestData>) => createQueryKey('salesGetRequest', options);

/**
 * Get Request
 */
export const salesGetRequestOptions = (options: Options<SalesGetRequestData>) => queryOptions<SalesGetRequestResponse, SalesGetRequestError, SalesGetRequestResponse, ReturnType<typeof salesGetRequestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesGetRequest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: salesGetRequestQueryKey(options)
});

export const salesListSupplierEvidenceQueryKey = (options?: Options<SalesListSupplierEvidenceData>) => createQueryKey('salesListSupplierEvidence', options);

/**
 * List Supplier Evidence
 */
export const salesListSupplierEvidenceOptions = (options?: Options<SalesListSupplierEvidenceData>) => queryOptions<SalesListSupplierEvidenceResponse, SalesListSupplierEvidenceError, SalesListSupplierEvidenceResponse, ReturnType<typeof salesListSupplierEvidenceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await salesListSupplierEvidence({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: salesListSupplierEvidenceQueryKey(options)
});

/**
 * Record Supplier Evidence
 */
export const salesRecordSupplierEvidenceMutation = (options?: Partial<Options<SalesRecordSupplierEvidenceData>>): UseMutationOptions<SalesRecordSupplierEvidenceResponse, SalesRecordSupplierEvidenceError, Options<SalesRecordSupplierEvidenceData>> => {
    const mutationOptions: UseMutationOptions<SalesRecordSupplierEvidenceResponse, SalesRecordSupplierEvidenceError, Options<SalesRecordSupplierEvidenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await salesRecordSupplierEvidence({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
